import { render, staticRenderFns } from "./loading-list-placeholder.vue?vue&type=template&id=50044d2a&lang=pug"
import script from "./loading-list-placeholder.vue?vue&type=script&lang=js"
export * from "./loading-list-placeholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports